module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade-up-slide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "lr2-modal",
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "lr-box",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "lr-box-head"
  }, [_vm._v("How many are you traveling with?")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-space-between trav-form"
  }, [_c('label', [_vm._v("Adults")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-center trav-counter"
  }, [_c('i', {
    class: ['fas fa-minus-circle', {
      maxed: _vm.adults === 1
    }],
    on: {
      "click": function($event) {
        _vm.minus('adults')
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.adults))]), _vm._v(" "), _c('i', {
    class: ['fas fa-plus-circle', {
      maxed: _vm.adults === 10
    }],
    on: {
      "click": function($event) {
        _vm.add('adults')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-space-between trav-form"
  }, [_c('label', [_vm._v("\n          Children\n          "), _c('span', [_vm._v("Ages 2 to 12")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-center trav-counter"
  }, [_c('i', {
    class: ['fas fa-minus-circle', {
      maxed: _vm.children === 0
    }],
    on: {
      "click": function($event) {
        _vm.minus('children')
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.children))]), _vm._v(" "), _c('i', {
    class: ['fas fa-plus-circle', {
      maxed: _vm.children === 10
    }],
    on: {
      "click": function($event) {
        _vm.add('children')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-space-between trav-form"
  }, [_c('label', [_vm._v("\n          Infants\n          "), _c('span', [_vm._v("Below 2 years old")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-center trav-counter"
  }, [_c('i', {
    class: ['fas fa-minus-circle', {
      maxed: _vm.infants === 0
    }],
    on: {
      "click": function($event) {
        _vm.minus('infants')
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.infants))]), _vm._v(" "), _c('i', {
    class: ['fas fa-plus-circle', {
      maxed: _vm.infants === 10
    }],
    on: {
      "click": function($event) {
        _vm.add('infants')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex trav-btn-box"
  }, [_c('span', {
    staticClass: "lr-btn",
    on: {
      "click": _vm.apply
    }
  }, [_vm._v("Search")])]), _vm._v(" "), _c('div', {
    staticClass: "trav-notes"
  }, [_vm._v("Note: Maximum of 2 luggage per passenger.")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-74e3f17a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74e3f17a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search/TravellersModal.vue
// module id = 2113
// module chunks = 0